export default __webpack_public_path__ + "static/B0096-9c7071b183c722ae786cbbaf71f8afad.png";